import removeAccents from 'remove-accents';
import { COUNTRIES } from '~components/CountrySelect/constants';
import { IirsaCountriesService } from '~/../config/services/iirsa_countries.service';

let apiFlagsByKey: Record<string, string> = {};
let pendingLoad: Promise<void> | null = null;
let listenerCount = 0;
const listeners: Set<() => void> = new Set();

function normalize(name: string): string {
    return removeAccents(name.trim()).toLowerCase();
}

function localFlagFor(name: string): string | null {
    const key = normalize(name);
    const match = COUNTRIES.find(c => normalize(c.label) === key);
    return match && match.icon ? (match.icon as string) : null;
}

function resolveFlagUrl(name: string): string | null {
    const key = normalize(name);
    if (apiFlagsByKey[key]) return apiFlagsByKey[key];
    return localFlagFor(name);
}

async function load(): Promise<void> {
    if (pendingLoad) return pendingLoad;
    pendingLoad = (async () => {
        try {
            const service = new IirsaCountriesService();
            const response = await service.get();
            const next: Record<string, string> = {};
            (response.data || []).forEach((c: { name?: string; flag?: string | null }) => {
                if (c && c.name && c.flag) {
                    next[normalize(c.name)] = c.flag;
                }
            });
            apiFlagsByKey = next;
            listeners.forEach(fn => fn());
        } catch (err) {
            // Network/API failure → callers fall back to local PNGs.
            // eslint-disable-next-line no-console
            console.warn('[flagResolver] failed to load /countries/', err);
        }
    })();
    return pendingLoad;
}

export const flagResolver = {
    resolve: resolveFlagUrl,
    ensureLoaded: load,
    subscribe(fn: () => void): () => void {
        listeners.add(fn);
        listenerCount += 1;
        if (listenerCount === 1) {
            load();
        }
        return () => {
            listeners.delete(fn);
            listenerCount = Math.max(0, listenerCount - 1);
        };
    },
};
